import {
  HoverCard,
  HoverCardTrigger,
  HoverCardContent,
  HoverCardPortal,
} from "~/components/shared/HoverCard";
import Icon from "~/components/shared/Icon";

interface InfoTooltipProps {
  title: string;
  description: string;
  items?: Array<string>;
}

export function InfoTooltip({ title, description, items }: InfoTooltipProps) {
  return (
    <HoverCard>
      <HoverCardTrigger asChild={true}>
        <button type="button" className="cursor-help">
          <Icon icon="info-circle" className="h-5 w-5 opacity-40" />
        </button>
      </HoverCardTrigger>
      <HoverCardPortal>
        <HoverCardContent size="max-lg" className="w-[320px] text-sm font-normal">
          <div className="max-w-xs">
            <p className="mb-1 font-medium">{title}</p>
            <p className="text-charcoal-400 text-sm">{description}</p>
            {items && (
              <ul className="text-charcoal-400 mt-2 text-sm">
                {items.map((item, index) => (
                  <li key={index}>• {item}</li>
                ))}
              </ul>
            )}
          </div>
        </HoverCardContent>
      </HoverCardPortal>
    </HoverCard>
  );
}
